
import { defineComponent, computed } from "vue";
import { usePlugin } from "./plugins";

export default defineComponent({
  name: "AppTopBar",
  // setup() {
  //   const { useState } = usePlugin();

  //   return { roles, isAdmin, isCompanyPlanner, isOperationPlanner, isViewer };
  // },
  methods: {
    onMenuToggle(event: any) {
      this.$emit("menu-toggle", event);
    },
  },
});
